export const breakdownData = {
  sectionHeading: {
    tag: 'Breakdown',
    title: 'Loan Agreement Overview',
    text: 'Comprehensive Breakdown of Loan Terms, APR Ranges, Representative Example, and Important Borrower Considerations',
  },
  breakdownCardsRowOne: [
    {
      title: "Representative Example",
      description: "For a $5,000 loan at a 10% APR over 36 months, the monthly repayment would be $161.34. Over the term, the total repayment would amount to $5,808.24, with $808.24 in interest.",
      image: {
        src: "assets/representativeChart.png",
        alt: "Representative Example"
      }
    },
    {
      title: "Loan Terms",
      description: "The loan terms range from 6 to 144 months (1 to 12 years), with APRs between 5.99% and 35.99%. The exact rate you receive depends on factors like your creditworthiness, loan size, and repayment schedule. Better rates are typically offered to those with excellent credit.",
    },
  ],
  breakdownCardsRowTwo: [
    {
      title: "Annual Percentage Rate (APR) Disclosure",
      description: "The loan terms range from 6 to 144 months (1 to 12 years), with APRs between 5.99% and 35.99%. The exact rate you receive depends on factors like your creditworthiness, loan size, and repayment schedule. Better rates are typically offered to those with excellent credit.",
    },
    {
      title: "Additional Considerations",
      description: "For secured loans, the loan is tied to an asset you own, which can be used as collateral if you fail to repay. It's essential to carefully review the lender's terms and conditions, as they will outline important details such as fees, requirements, and any restrictions before you proceed with the loan.",
    },
  ]
};
